import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { code, em, strike, strong, subsup, underline } from '@atlaskit/adf-schema';
import { toggleCodeWithAnalytics, toggleEmWithAnalytics, toggleStrikeWithAnalytics, toggleStrongWithAnalytics, toggleSubscriptWithAnalytics, toggleSuperscriptWithAnalytics, toggleUnderlineWithAnalytics } from './commands';
import { plugin as clearFormattingPlugin, pluginKey as clearFormattingPluginKey } from './pm-plugins/clear-formatting';
import clearFormattingKeymapPlugin from './pm-plugins/clear-formatting-keymap';
import textFormattingCursorPlugin from './pm-plugins/cursor';
import textFormattingInputRulePlugin from './pm-plugins/input-rule';
import keymapPlugin from './pm-plugins/keymap';
import { plugin as pmPlugin, pluginKey as textFormattingPluginKey } from './pm-plugins/main';
import textFormattingSmartInputRulePlugin from './pm-plugins/smart-input-rule';
import { PrimaryToolbarComponent } from './ui/PrimaryToolbarComponent';
/**
 * Text formatting plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */
export var textFormattingPlugin = function textFormattingPlugin(_ref) {
  var _api$analytics6, _api$analytics7, _api$analytics8, _api$analytics9, _api$analytics10, _api$analytics11, _api$analytics12;
  var options = _ref.config,
    api = _ref.api;
  return {
    name: 'textFormatting',
    marks: function marks() {
      return [{
        name: 'em',
        mark: em
      }, {
        name: 'strong',
        mark: strong
      }].concat(options !== null && options !== void 0 && options.disableStrikethrough ? [] : {
        name: 'strike',
        mark: strike
      }).concat(options !== null && options !== void 0 && options.disableCode ? [] : {
        name: 'code',
        mark: code
      }).concat(options !== null && options !== void 0 && options.disableSuperscriptAndSubscript ? [] : {
        name: 'subsup',
        mark: subsup
      }).concat(options !== null && options !== void 0 && options.disableUnderline ? [] : {
        name: 'underline',
        mark: underline
      });
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'textFormatting',
        plugin: function plugin(_ref2) {
          var _api$analytics;
          var dispatch = _ref2.dispatch;
          return pmPlugin(dispatch, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
        }
      }, {
        name: 'textFormattingCursor',
        plugin: function plugin() {
          return textFormattingCursorPlugin;
        }
      }, {
        name: 'textFormattingInputRule',
        plugin: function plugin(_ref3) {
          var _api$analytics2;
          var schema = _ref3.schema;
          return textFormattingInputRulePlugin(schema, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
        }
      }, {
        name: 'textFormattingSmartRule',
        plugin: function plugin() {
          var _api$analytics3;
          return !(options !== null && options !== void 0 && options.disableSmartTextCompletion) ? textFormattingSmartInputRulePlugin(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions) : undefined;
        }
      }, {
        name: 'textFormattingClear',
        plugin: function plugin(_ref4) {
          var dispatch = _ref4.dispatch;
          return clearFormattingPlugin(dispatch);
        }
      }, {
        name: 'textFormattingClearKeymap',
        plugin: function plugin() {
          var _api$analytics4;
          return clearFormattingKeymapPlugin(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions);
        }
      }, {
        name: 'textFormattingKeymap',
        plugin: function plugin(_ref5) {
          var _api$analytics5;
          var schema = _ref5.schema;
          return keymapPlugin(schema, api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions);
        }
      }];
    },
    getSharedState: function getSharedState(editorState) {
      var _clearFormattingPlugi;
      if (!editorState) {
        return undefined;
      }
      return _objectSpread(_objectSpread({}, textFormattingPluginKey.getState(editorState)), {}, {
        formattingIsPresent: (_clearFormattingPlugi = clearFormattingPluginKey.getState(editorState)) === null || _clearFormattingPlugi === void 0 ? void 0 : _clearFormattingPlugi.formattingIsPresent
      });
    },
    primaryToolbarComponent: function primaryToolbarComponent(_ref6) {
      var editorView = _ref6.editorView,
        popupsMountPoint = _ref6.popupsMountPoint,
        popupsScrollableElement = _ref6.popupsScrollableElement,
        isToolbarReducedSpacing = _ref6.isToolbarReducedSpacing,
        toolbarSize = _ref6.toolbarSize,
        disabled = _ref6.disabled;
      return /*#__PURE__*/React.createElement(PrimaryToolbarComponent, {
        api: api,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isToolbarReducedSpacing,
        editorView: editorView,
        disabled: disabled,
        shouldUseResponsiveToolbar: Boolean(options === null || options === void 0 ? void 0 : options.responsiveToolbarMenu)
      });
    },
    commands: {
      toggleSuperscript: toggleSuperscriptWithAnalytics(api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 ? void 0 : _api$analytics6.actions),
      toggleSubscript: toggleSubscriptWithAnalytics(api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 ? void 0 : _api$analytics7.actions),
      toggleStrike: toggleStrikeWithAnalytics(api === null || api === void 0 || (_api$analytics8 = api.analytics) === null || _api$analytics8 === void 0 ? void 0 : _api$analytics8.actions),
      toggleCode: toggleCodeWithAnalytics(api === null || api === void 0 || (_api$analytics9 = api.analytics) === null || _api$analytics9 === void 0 ? void 0 : _api$analytics9.actions),
      toggleUnderline: toggleUnderlineWithAnalytics(api === null || api === void 0 || (_api$analytics10 = api.analytics) === null || _api$analytics10 === void 0 ? void 0 : _api$analytics10.actions),
      toggleEm: toggleEmWithAnalytics(api === null || api === void 0 || (_api$analytics11 = api.analytics) === null || _api$analytics11 === void 0 ? void 0 : _api$analytics11.actions),
      toggleStrong: toggleStrongWithAnalytics(api === null || api === void 0 || (_api$analytics12 = api.analytics) === null || _api$analytics12 === void 0 ? void 0 : _api$analytics12.actions)
    }
  };
};